module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjBAMAAAB9FaOmAAAAElBMVEXOESbOESbGAAPpkpz////////PfRXIAAAABnRSTlPx//3v//H1IGy+AAAAPElEQVRYw+3WsREAIAwCQI8JdP9lnSEpYuHT/1HQkFVOTjU7jRYEQRAEQZBPSONczRBTIgiCIAiCPH19F66hEVw1h/o8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Indonesia.png
// module id = 579
// module chunks = 0